// All calls to the backend. Admin calls send the signed token stored after login.
const BASE = process.env.REACT_APP_API_URL || '/api';
const TOKEN_KEY = 'elegance_admin_token';

export const getToken = () => {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
};
export const setToken = (t) => {
  try { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); } catch { /* storage blocked */ }
};

async function request(path, options = {}, timeoutMs = 20000) {
  const token = getToken();
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), timeoutMs);
  try {
    const res = await fetch(`${BASE}${path}`, {
      ...options,
      signal: ctrl.signal,
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...options.headers,
      },
    });
    const raw = await res.json().catch(() => ({}));
    if (res.status === 401 && token && !path.startsWith('/admin/login')) {
      setToken(null);
      window.dispatchEvent(new Event('elegance:unauthorized'));
    }
    if (!res.ok) throw new Error(raw.error || `Request failed (${res.status})`);
    return raw && typeof raw === 'object' && 'data' in raw ? raw.data : raw;
  } catch (e) {
    if (e.name === 'AbortError') throw new Error('The server took too long to respond');
    throw e;
  } finally {
    clearTimeout(timer);
  }
}

const json = (method, body) => ({ method, body: JSON.stringify(body) });

const api = {
  health: () => request('/health', {}, 7000),
  settings: () => request('/settings'),
  saveSettings: (s) => request('/settings', json('PUT', s)),
  products: () => request('/products'),
  product: (id) => request(`/products/${id}`),
  addProduct: (p) => request('/products', json('POST', p)),
  updateProduct: (id, p) => request(`/products/${id}`, json('PUT', p)),
  deleteProduct: (id) => request(`/products/${id}`, { method: 'DELETE' }),
  placeOrder: (o) => request('/orders', json('POST', o)),
  orders: () => request('/orders'),
  setOrderStatus: (id, status) => request(`/orders/${id}/status`, json('PATCH', { status })),
  deleteOrder: (id) => request(`/orders/${id}`, { method: 'DELETE' }),
  stats: () => request('/admin/stats'),
  login: async (username, password, otp) => {
    const data = await request('/admin/login', json('POST', { username, password, otp }));
    setToken(data.token);
    return data;
  },
  me: () => request('/admin/me'),
  upload: (dataUrl) => request('/admin/upload', json('POST', { dataUrl })),
};

export default api;
